import React from "react";


const FilterIcon = props => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="19.595" height="20" viewBox="0 0 19.595 20">
            <g id="Group_89" data-name="Group 89" transform="translate(-1327.698 -157.159)">
                <path id="Path_319" data-name="Path 319" d="M21.091,21v9.818L17,28.364V21" transform="translate(1318.243 145.341)" fill="none" stroke="rgba(23,41,81,0.7)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                <path id="Path_320" data-name="Path 320" d="M18.182,2.227,11.636,9.182H7.545L1,2.227V1H18.182V2.227" transform="translate(1327.698 157.159)" fill="none" stroke="rgba(23,41,81,0.7)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
            </g>
        </svg>
    );

}

export default FilterIcon;